export const COMMUNITY_CONFIG = {
  emptyFeedText: 'No posts yet. Check back soon for new community updates.',
  errorFeedText: 'Could not load the community feed. Please try again.',
  postTypeLabels: {
    action_spotlight: 'Action spotlight',
    reward: 'Reward',
    partner: 'Partner',
    challenge: 'Challenge',
    education: 'Education',
  },
  statusLabels: {
    draft: 'Draft',
    published: 'Published',
    archived: 'Archived',
  },
  defaultCtaText: 'Learn more',
};

